export const REQUEST_TIMEOUT = 20000;
export const ZIPCODE_LENGTH = 5;
export const MAX_ALTERNATE_PHONES = 3;
export const sessionStorageKeys = {
  recentlyViewedItems: 'rvData',
  recentlyViewedDatestamp: 'RVDateStamp',
};

export const EXTERNAL_HOST_PATH =
  typeof window !== 'undefined' && typeof window?.THD_GLOBAL !== 'undefined'
    ? window?.THD_GLOBAL?.nonSecureHostName
    : '';
export const SIGN_IN_HOST_PATH = `${EXTERNAL_HOST_PATH}/auth/view/signin`;

export const ACCOUNT_BREADCRUMBS_BASE = [
  { url: '/', label: 'Home' },
  { url: '/myaccount/dashboard', label: 'Account' },
];

export const B2B_BREADCRUMBS = {
  pricingBenefits: [
    {
      label: 'Pricing Benefits',
      url: '/myaccount/proXtraPricing',
    },
  ],
};

export const B2B_REGISTRATION_PAGE_BREADCRUMBS = {
  pricingRegistration: [
    {
      label: 'Preferred Pricing',
      url: '/myaccount/proXtraPricing',
    },
    {
      label: 'Registration',
      url: '/myaccount/proXtraPricing/registration',
    },
  ],
};

export const B2B_ANALYTICS = {
  pricingBenefits: {
    category: {
      primaryCategory: 'account',
      subCategory1: 'account>pricing benefits',
      subCategory2: 'account>pricing benefits',
    },
    pageInfo: {
      pageName: 'account>pricing benefits',
      pageType: 'maml:pricing',
    },
    error: [],
  },
};
